"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSessionPlayerStatus = void 0;
var GameSessionPlayerStatus;
(function (GameSessionPlayerStatus) {
    /**
     * Player is pending to join the game session for first time.
     */
    GameSessionPlayerStatus["Pending"] = "pending";
    GameSessionPlayerStatus["Joined"] = "joined";
    GameSessionPlayerStatus["Ready"] = "ready";
    /**
     * Player left game session after joining.
     */
    GameSessionPlayerStatus["Left"] = "left";
})(GameSessionPlayerStatus = exports.GameSessionPlayerStatus || (exports.GameSessionPlayerStatus = {}));
//# sourceMappingURL=game-session-player-status.js.map